// extracted by mini-css-extract-plugin
module.exports =  {"Summary":"Summary-module__Summary___k87UI","Info":"Summary-module__Info___NMVvB"};